import React from "react";

const JobOpeningListData = (props) => {
  return (
    <tr class="bg-white border-b hover:bg-gray-50 dark:hover:bg-gray-200">
      <td class="px-10 py-4">
        <input type="checkbox" />
      </td>
      <td scope="row" class="px-10 py-4 whitespace-nowrap">
        {props.requestdata.id}
      </td>
      <td class="px-10 py-4 flex items-center gap-3 border-0 text-blue-600">
        {props.requestdata.offboarding_name}
      </td>
      <td class="px-10 py-4">{props.requestdata.recruiter}</td>
      <td class="px-10 py-4">{props.requestdata.created_date}</td>
      <td class="px-10 py-4">{props.requestdata.hiring_target}</td>
      <td class="px-10 py-4">{props.requestdata.candidates}</td>
      <td class="px-10 py-4">{props.requestdata.hired}</td>
      <td class="px-10 py-4 flex justify-between items-center border-none">
        <img
          src="/images/edit-black-icon.svg"
          alt=""
          className="cursor-pointer"
        />
        <i className="ico-more text-gray-500 cursor-pointer pl-5"></i>
      </td>
    </tr>
  );
};

export default JobOpeningListData;
